import { useTranslations } from 'next-intl';
import { Button, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

interface TranscriptADProps {
  onClose?: () => void;
  onTranscriptRequest?: () => void;
}

export function TranscriptADPopup({ onClose, onTranscriptRequest }: TranscriptADProps) {
  const t = useTranslations('features');

  return (
    <div
      className="rounded-lg"
      style={{
        background: 'linear-gradient(170deg, rgba(0, 188, 212, 0.00) 7.61%, rgba(0, 188, 212, 0.06) 114.06%), #F9FAFD',
      }}
    >
      <div>
        <div
          className="cursor-pointer mb-2 text-gray-400 hover:text-gray-700 absolute top-[22px] right-[22px]"
          style={{ width: 18, height: 18 }}
          onClick={onClose}
        >
          <Icon icon={IconsMap.CLOSE} />
        </div>
      </div>
      <div
        className="flex flex-row items-start justify-start pl-[52px] pt-12 rounded-lg w-[883px] h-[477px]"
        style={{
          backgroundImage: 'url(/assets/img/transcript-ad.png)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right bottom',
          backgroundSize: '583px 430px',
        }}
      >
        <div className="w-[360px]">
          <h2 className="text-[32px] leading-[120%] font-bold text-gray-800 mb-3 tracking-[-0.64px]">
            {t('transcript.transcribe_this_video')}
          </h2>
          <p className="text-black text-base mb-6 font-normal">
            {t.rich('transcript.our_ai_transforms_videos', {
              strong: (chunk) => <span className="font-semibold">{chunk}</span>,
            })}
          </p>
          <p className="text-base font-semibold text-cyan-800">{t('transcript.speed_up_workflow')}</p>

          <div className="mt-[130px]">
            <Button type={ButtonType.FLAT} className="w-[172px]" onClick={onTranscriptRequest}>
              {t('transcript.try_now')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
